import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {parserMainClass} from "../../classes/parsers/mainParser";
import {parserFactory} from "../../classes/parsers/parseFactory";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {AutoCadService} from "../../services/CADService/auto-cad.service";
import {HintManagerService} from "../../services/hintManager/hint-manager.service";
import {timer} from "rxjs";
import {animateShow} from "../../animations/showHideAnimation";
import {MapPosition} from "../../models/MapPosition";
import {OverlayService} from "../../services/overlay/overlay.service";
import {Overlay} from "../../services/overlay/Overlay";

@Component({
  selector: 'app-cad-auto-import',
  templateUrl: './cad-auto-import.component.html',
  styleUrls: ['./cad-auto-import.component.scss'],
  animations: [animateShow]
})
export class CadAutoImportComponent implements OnInit{
  public Yiit = Yiit;
  @ViewChild('fileInput', {static: false}) fileInput;
  private parser:parserMainClass;
  public isCadLoaded = false;
  public opacity = null;
  public pendingOverlays: Overlay[] = [];

  constructor(
    private cad: AutoCadService,
    private parserFactory: parserFactory,
    private bsModal: EsBsModalService,
    private hintManager: HintManagerService,
    private overlayService: OverlayService,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.cad.isCadPlaced$.subscribe((value)=>{
      this.isCadLoaded = value;
      this.cd.detectChanges();
    });
    this.cad.cadOpacityUpdated.subscribe((value)=>{
      if (value == this.opacity){
        return;
      }
      this.opacity = parseFloat(value);
      this.cd.detectChanges();
    });
    this.overlayService.getAutoImportPendingLayouts().subscribe(value => {
      this.pendingOverlays = value;
      this.cd.detectChanges();
    });


    this.cd.detectChanges();
  }

  setCadOpacity(event){
    this.opacity = event;
    this.cad.cadOpacity = this.opacity;
  }

  addHint(){
    this.hintManager.isTimeoutHint = true;
    this.hintManager.hintText = 'Please select an image file';
    this.cd.detectChanges();
  }

  checkForEmpty(event){
  }

  autoPositionExistingCAD(overlay: Overlay) {
    if (!overlay || !overlay.imageUrl || !overlay.pendingCadConfig) {
      alert("Corrupted overlay");
      return;
    }
    this.cad.clearPreviouslyImportedCad();
    this.cad.activePendingOverlay = overlay;
    this.cad.currentCADUrl = overlay.imageUrl;
    this.cad.addPreviewCAD();
    console.log('overlay.pendingCadConfig', overlay.pendingCadConfig)

    for (let i = 0; i < overlay.pendingCadConfig.imagePoints.length; i++) {
      this.cad.addMarker({imgPosition: overlay.pendingCadConfig.imagePoints[i]});
      this.cad.addMapPositionToMarker(new MapPosition(overlay.pendingCadConfig.mapPoints[i]));
    }

    this.cad.synchronizeMarkers();

    timer(3000).subscribe(()=>{
      this.cd.detectChanges();
    });
  }

  /**
   * file - any jpg file for now
   */
  uploadCADFile(event){
    let file:File = event.target.files[0];
    if (!file){
      return;
    }
    this.parser = this.parserFactory.createParserByType(file);
    this.cad.clearMarkers();
    this.parser.getData().subscribe((url)=>{
      this.cad.clearPreviouslyImportedCad();
      this.cad.currentCADUrl = url;
      this.cad.addPreviewCAD();
      event.target.files = null;

      timer(3000).subscribe(()=>{
        this.cd.detectChanges();
      });
      // this.bsModal.openModal({modalId: '#cad-auto-import-modal'});
    });
    this.cad.fileOptions = this.parser.getFileOptions();
  }

  lambert93toWGPS(lambertE, lambertN) {

    var constantes = {
      GRS80E: 0.081819191042816,
      LONG_0: 3,
      XS: 700000,
      YS: 12655612.0499,
      n: 0.7256077650532670,
      C: 11754255.4261
    }

    var delX = lambertE - constantes.XS;
    var delY = lambertN - constantes.YS;
    var gamma = Math.atan(-delX / delY);
    var R = Math.sqrt(delX * delX + delY * delY);
    var latiso = Math.log(constantes.C / R) / constantes.n;
    var sinPhiit0 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * Math.sin(1)));
    var sinPhiit1 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit0));
    var sinPhiit2 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit1));
    var sinPhiit3 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit2));
    var sinPhiit4 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit3));
    var sinPhiit5 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit4));
    var sinPhiit6 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit5));

    var longRad = Math.asin(sinPhiit6);
    var latRad = gamma / constantes.n + constantes.LONG_0 / 180 * Math.PI;

    var longitude = latRad / Math.PI * 180;
    var latitude = longRad / Math.PI * 180;

    return {lng: longitude, lat: latitude};
  }

}
